/*eslint-disable react/no-unescaped-entities */
import React from 'react';
import { Tooltip } from '@material-ui/core';
import '../../enrollment.scss';

const LifeEventOption = ({
  lifeEventName,
  onClickHandler,
  showEffectiveDate,
  description,
  employerApproval,
  insurerApproval,
}) => {
  return (
    <Tooltip
      className="enrollment-tooltip"
      placement="bottom"
      title={
        <div className="enrollment-tooltip-container">
          {/*<div className="dashboard-tooltip-header">{lifeEventName}</div> */}
          <div>{description}</div>
        </div>
      }
      arrow
    >
      <div
        role="button"
        className="life-event-button"
        onClick={() => {
          onClickHandler(
            lifeEventName,
            showEffectiveDate,
            employerApproval,
            insurerApproval,
          );
        }}
      >
        {lifeEventName}
      </div>
    </Tooltip>
  );
};

export default LifeEventOption;
